import { StepIndicator as ChakraStepIndicator } from '@chakra-ui/react'

import { StepIndicatorProps } from './StepIndicator.types'

export default function StepIndicator(props: StepIndicatorProps) {
  return <ChakraStepIndicator {...props} translate="no" />
}
